import { Check, Users, Zap, Star, Crown, Building2 } from "lucide-react";

const TIER_ICONS = { free: Users, founding: Zap, professional: Star, featured: Crown };

export const TierCard = ({ tier, isSelected, onClick, isFounding, foundingSpotsLeft, maxFeatures = 4 }) => {
  const Icon = TIER_ICONS[tier.name] || Users;
  const isGradient = tier.visual_upgrade_style === "gradient";
  const isSoldOut = isFounding && foundingSpotsLeft <= 0;

  return (
    <div
      onClick={() => !isSoldOut && onClick(tier.name)}
      className={`relative p-5 rounded-xl border-2 transition-all ${isSoldOut ? "opacity-50 cursor-not-allowed" : "cursor-pointer"} ${
        isSelected ? "ring-2" : "border-[#D1CFC5] hover:border-[#5C5A52]"
      } ${isGradient ? "bg-gradient-to-br from-[#1A2F23] to-[#2C4A3B] text-white" : isFounding ? "bg-[#14B8A6]/5" : "bg-[#F7F6F2]"}`}
      style={isSelected ? { borderColor: isFounding ? "#14B8A6" : "#2C4A3B" } : {}}
      data-testid={`tier-card-${tier.name}`}
    >
      {isFounding && foundingSpotsLeft > 0 && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-bold px-3 py-1 rounded-full bg-[#14B8A6] text-white">
          {foundingSpotsLeft} SPOTS LEFT
        </div>
      )}
      <div className="text-center mb-4">
        <Icon className="w-8 h-8 mx-auto mb-2" style={{ color: isGradient ? "#D4A017" : isFounding ? "#14B8A6" : "#2C4A3B" }} />
        <h3 className={`font-heading text-lg font-bold ${isGradient ? "text-white" : "text-[#1A1915]"}`}>{tier.display_name}</h3>
      </div>
      <div className="text-center mb-4">
        <span className={`text-3xl font-bold ${isGradient ? "text-white" : "text-[#1A1915]"}`}>${tier.price_yearly}</span>
        <span className={`text-sm ${isGradient ? "text-white/70" : "text-[#5C5A52]"}`}>/yr</span>
      </div>
      <ul className="space-y-2 text-sm">
        {tier.features.slice(0, maxFeatures).map((f, i) => (
          <li key={`feat-${i}-${f.slice(0,10)}`} className={`flex items-start gap-2 ${isGradient ? "text-white/80" : "text-[#5C5A52]"}`}>
            <Check className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: isFounding ? "#14B8A6" : "#2C4A3B" }} />{f}
          </li>
        ))}
      </ul>
      {isSelected && (
        <div className="absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: isFounding ? "#14B8A6" : "#2C4A3B" }}>
          <Check className="w-4 h-4 text-white" />
        </div>
      )}
    </div>
  );
};

export const SponsorTierCard = ({ tier, isSelected, onClick }) => (
  <div
    onClick={() => onClick(tier.name)}
    className={`relative p-5 rounded-xl border-2 cursor-pointer transition-all ${isSelected ? "border-[#1E3A5F]" : "border-[#D1CFC5]"}`}
    style={{ backgroundColor: isSelected ? `${tier.badge_colors.primary}10` : "#F7F6F2" }}
    data-testid={`sponsor-card-${tier.name}`}
  >
    <div className="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center"
      style={{ backgroundColor: tier.badge_colors.primary, border: `3px solid ${tier.badge_colors.secondary}` }}>
      <Building2 className="w-6 h-6" style={{ color: tier.badge_colors.secondary }} />
    </div>
    <h3 className="font-heading text-lg font-bold text-center text-[#1A1915] mb-2">{tier.display_name}</h3>
    <p className="text-center text-2xl font-bold text-[#1A1915] mb-1">${tier.min_contribution.toLocaleString()}</p>
    <p className="text-center text-sm text-[#5C5A52] mb-4">per year</p>
    <ul className="space-y-2 text-sm">
      {tier.features.map((f, i) => (
        <li key={`sfeat-${i}-${f.slice(0,10)}`} className="flex items-start gap-2 text-[#5C5A52]">
          <Check className="w-4 h-4 mt-0.5 text-[#1E3A5F] flex-shrink-0" />{f}
        </li>
      ))}
    </ul>
    {isSelected && (
      <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-[#1E3A5F] flex items-center justify-center">
        <Check className="w-4 h-4 text-white" />
      </div>
    )}
  </div>
);
